<template>
    <a v-if="show" :href="banner.link" class="t-banner" target="_blank">
        <img class="t-banner__img" :class="{'t-banner__img_mobile':mobileState}" :src="mobileState?banner.imgMobile:banner.img">
    </a>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        // props: ['data', 'isProfile'],
        computed: {
            ...mapGetters(['mobileState'])
        },
        data() {
            return {
                banner: {
                    img: '',
                    imgMobile:'',
                    link: '#'
                },
                show: false
            }
        },
        created() {
            let url = process.env.NODE_ENV !== 'production' ? 'banner.json' : 'recblock/banner';
            this.$http.get(url)
                .then(response => response.json())
                .then(data => {
                    // commit('setRecommendations', data);
                    this.banner = data.items[0];
                    if (this.banner){
                        this.show = true;
                    }
                })
        },
        methods: {
            // ...mapActions('profile', ['LoadDocuments']),
            // DelDocument() {
            //     this.$http.delete('banners/' + this.data.id)
            //         .then(response => response.json())
            //         .then(data => {
            //             if (data.success) {
            //                 this.LoadDocuments({page: this.$route.query.page});
            //             }
            //         })
            // },
            // Click() {
            //     this.$emit('ViewImage')
            // }
        }
    }
</script>

<style lang="sass">
    .t-banner
        display: block
        width: 100%
        margin-top: 32px
        margin-bottom: 32px
        border-radius: 16px
        overflow: hidden
        transition: box-shadow .3s
        &:hover
            // background: white
            box-shadow: $shadow
            // box-shadow: 0px 24px 32px rgba(0, 108, 202, 0.1)
        &__img
            width: 100%
            height: auto // 184px
            height-max: 220px
            display: flex
            align-items: center
            justify-content: center
            object-fit: contain
            &_mobile

        @media(max-width: 769px)
            .t-banner
                flex-wrap: wrap
                padding: 0
                justify-content: space-between
                &:not(:last-child)
                    margin-bottom: 24px
                &__name
                    width: 100%
                    flex: none
                    order: 3
                    margin-top: 8px
                &__remove
                    width: 102px
                    padding-top: 5px
                    text-align: right
                &__del
                    position: relative
                    top: 0
                    right: 0
                    order: 2
                    margin: 0
</style>


// WEBPACK FOOTER //
// src/vue_components/Banner.vue